import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap';
// import { MatDialog, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/api-services/common.service';
import { MasterService } from 'src/app/api-services/master.service';
import { PartSearchComponent } from 'src/app/shared/part-search/part-search.component';
import { ActivatedRoute, Router } from "@angular/router";
import { LoginService } from 'src/app/api-services/login.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
// import { PartCostComponent } from 'src/app/shared/part-cost/part-cost.component';
declare var $: any;

@Component({
  selector: 'app-po-details',
  templateUrl: './po-details.component.html',
  styleUrls: ['./po-details.component.scss']
})
export class PoDetailsComponent implements OnInit {

 

    @ViewChild('staticTabs') staticTabs: TabsetComponent;
    public isShowPageLoader:boolean=false;
    public lang:any;
    public partHeader:Array<any>=[];
    poTypeArr=[];
    public creditAvailable:any;
    today=new Date();
    venName:any;
    saveObj:any={
      "dealerId": 0,
      "branchId": 0,
      "companyId": 0,
      "countryCode": "",
      "vendorId": '',
      "vendorCategoryId":null,
      "duration": 0,
      "orderType": null,
      "rowState": 0,
      "totalVal": 0,
      "createdBy": "",
      "active": true,
      "is_So_Create": true,
      "SparesPODetails": [
      ]
    };
    sparPartsArr:any=[{
      "sparePartId": null,
      "chkSelect": true,
      "manuf_Id": 0,
      "uom_Id": "",
      "orderQty": null,
      "adjusted_Qty": 0,
      "pending_Qty": 0,
      "openQty": 0,
      "freeQty": 0,
      "recvQty": 0,
      "amount": 0,
      "invoicePrice": 0,
      "tvsPaidTax": 0,
      "is_PO_Qty_change": false,
      "config_Value": true,
      "block_ord": false,
  
      "partArr":[],
      "partDesc":"",
      "sparDet":null,
      "sparpartNo":null,
      "calculDet":null
    }]
    vendorArr:any=[];
    companyDetail: any;
    editId: any;
    editData: any;
    partSrc:any;
    public status: any = [
      {
        name: 'Open',
        value: '1'
      },
      {
        name: 'Closed',
        value: '2'
      },
      {
        name: 'Cancelled',
        value: '3'
      },
      {
        name: 'Uploaded',
        value: '4'
      },
      {
        name: 'PartillyInwarded',
        value: '5'
      }
      ,
      {
        name: 'Confirmed',
        value: '6'
      }
      ,
      {
        name: 'UpdatedInSAP',
        value: '7'
      }
    ];
    pageType: string;
    uploadData: string;
    poType:string = "";
  
    constructor(
      public dialog: MatDialog,
      private router:Router,private loginService:LoginService,private httpClient: HttpClient,
      public toastr: ToastrService,private masterServices: MasterService,private route:ActivatedRoute
    ) {
      this.editId=this.route.snapshot.queryParamMap.get('id');      
      this.getViewData()
     }
  
    ngOnInit() {
        this.httpClient.get('assets/i18n/' + 'en.json').subscribe(
          langResp => {
            this.lang =langResp; 
            this.partHeader = [
              {
                name: this.lang.PART.partNo,
                width: 'wmpx-200'
              },
              {
                name: this.lang.PART.partDesc,
                width: 'wmpx-200'
              },
              {
                name: this.lang.PART.orderQty ,
                width: 'wmpx-150'
              },           
              {
                name: this.lang.PART.invPrice,
                width: 'wmpx-150'
              },
              {
                name: this.lang.PART.tax,
                width: 'wmpx-150'
              },
             
              {
                name: this.lang.PART.minOrderQty,
                width: 'wmpx-150'
              },
              
              {
                name: this.lang.PART.uom,
                width: 'wmpx-150'
              }
            ];       
        }); 
    }
    
    addnewSpar(limit,data){
      
     
      if(data) this.sparPartsArr=[];
        for(let i=0;i<limit;i++){
          var obj:any={
            "sparePartId": null,
            "chkSelect": true,
            "manuf_Id": 0,
            "uom_Id": "string",
            "orderQty": null,
            "adjusted_Qty": 0,
            "pending_Qty": 0,
            "openQty": 0,
            "freeQty": 0,
            "recvQty": 0,
            "amount": 0,
            "invoicePrice": 0,
            "tvsPaidTax": 0,
            "is_PO_Qty_change": false,
            "config_Value": true,
            "block_ord": false,
            "partArr":[],
            "partDesc":"",
            "sparDet":{},
            "sparpartNo":null,
            "calculDet":null
          };
          if(!data&&this.editId){
            obj.row_state=0;
          }
          else if(data&&this.editId){obj.row_state=1;}
          if(data){
            obj.calculDet=data[i];
            obj.sparDet=data[i];
            obj.orderQty=Number(data[i].ORDER_QTY);
            obj.partDesc=data[i].DESCRIPTION;
            obj.sparpartNo=data[i].PART_NO;
            obj.sparePartId=data[i].SPARE_PART_ID;
          }
          if (this.sparPartsArr && this.sparPartsArr.length > 0) {
            let partError: any = 0;
            this.sparPartsArr.filter(val => {
              if (!val.sparePartId) {
                partError++;
              };
            });
            if (partError >= 1) {
              return;
            }
          }
          this.sparPartsArr.push(obj);
        }
       
        if(this.editId){
          this.totalAmt();        
        }
      }
  
  
      
  
   
  
  
   
  
    totalAmt(){
      let totalAmount: any = 0;
      if (this.sparPartsArr.length > 0 && this.sparPartsArr) {
        this.sparPartsArr.filter(key => {
        if(key.calculDet){
        totalAmount += key.calculDet.AMOUNT;
        }
        });
      }
      this.saveObj.totalVal=totalAmount?Math.round(totalAmount):0;
    }
   


    confirmPO(){
      let reqData = {
        header: this.lang.GENERAL.confirm,
        message: this.lang.GENERAL.confirmPOD,
        btnName1: this.lang.GENERAL.yes,
        btnName2: this.lang.GENERAL.cancel
      }
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '400px',
        data: reqData,
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
       if(result){
        this.isShowPageLoader = true;
        
        const body ={
          DealerId: this.editData.DEALER_ID,
          BranchId: this.editData.BRANCH_ID,
          SparePOId: this.editData.SPARE_PO_ID
        }
        this.masterServices.post(body,'/PurchaseOrder/ConfirmPOSubmittionDrivex')
        .subscribe((resp: any) => {
          console.log(resp);
          if (resp && resp.statusCode == 200) {
            this.isShowPageLoader = false;
            this.toastr.success(resp.statusMessage);
          }
          else{
            this.isShowPageLoader = false;
            this.toastr.error(resp.statusMessage);
          }
         
        }, error => {          
          this.isShowPageLoader = false;
          this.toastr.error(error.statusMessage);
         });
       }
      })
    }

    getViewData(){
      this.masterServices.get('','/PurchaseOrder/getViewPurchaseOrderDrivexFromToken?id='+this.editId).subscribe(
        (resp: any) => {
          if (resp && resp.statusCode == 200) {
            this.editData=resp.sparePurchaseInfo;
            this.saveObj.orderType=this.editData.ORDER_TYPE;
            this.saveObj.vendorCategoryId=this.editData.VENDOR_CATEGORY_ID;
            this.saveObj.vendorId=this.editData.VENDOR_ID;
            
            this.addnewSpar(this.editData.SparesPODetails.length,this.editData.SparesPODetails)
           
          }
         
          }, error => {
          
          this.isShowPageLoader = false;
          this.toastr.error(error.statusMessage);
         }
      );
    }
   
   
    
    
    partCount(){
      let count:any =0;
      if(this.sparPartsArr && this.sparPartsArr.length >0 ){
        this.sparPartsArr.filter(val =>{
          if(val.sparePartId && val.orderQty){
            count++;
          }
        });
      }
      return count;
    }
    
  
    
    
    goback(){
      this.router.navigate(['/session/dealer']);
    }
  }
